import { registerQuery, registerMutation } from 'data-fetching-client';
import { createRpcClientV2 } from 'rpc-client-utils';
import hubHttpClient from 'hub-http/clients/apiClient';
import { searchPropertiesWithPagingRpc, recordPropertyClickedEventRpc } from 'automation-ui-canvas/__generated__/chirp/com/hubspot/nlp/crm/search/rpc/propertysearch/NlpPropertySearchService';
const chirpClient = createRpcClientV2({
  hubHttpClient
});
const DEFAULT_PROPERTY_SEARCH_FILTERS = {
  hidden: false
};
export const SEARCH_PROPERTIES_USING_NLP = registerQuery({
  fieldName: 'searchPropertiesUsingNlp',
  args: ['searchTerm', 'pageLength', 'resultLimit', 'offset'],
  fetcher: ({
    searchTerm,
    pageLength = 25,
    resultLimit = 100,
    similarityThreshold = 0.75,
    offset = 0,
    objectTypeIdAllowList
  }) => chirpClient.call(searchPropertiesWithPagingRpc, {
    timeout: 20000,
    request: {
      input: searchTerm,
      pageLength,
      resultLimit,
      similarityThreshold,
      offset: {
        index: offset
      },
      propertySearchFilters: Object.assign({}, DEFAULT_PROPERTY_SEARCH_FILTERS, {
        objectTypeIdAllowList
      }),
      checkFieldLevelPermissions: true
    }
  })
});
export const RECORD_PROPERTY_CLICKED_EVENT = registerMutation({
  fieldName: 'recordPropertyClickedEvent',
  fetcher: ({
    searchTerm,
    selectedProperty,
    searchResults,
    objectTypeIdAllowList
  }) => chirpClient.call(recordPropertyClickedEventRpc, {
    request: {
      input: searchTerm,
      clickedResult: selectedProperty,
      servedResponseResults: searchResults,
      propertySearchFilters: Object.assign({}, DEFAULT_PROPERTY_SEARCH_FILTERS, {
        objectTypeIdAllowList
      })
    }
  })
});